module.exports = __webpack_public_path__ + "img/ht_img_tablet.a827df52.svg";